import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=0856580b&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=0856580b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856580b",
  null
  
)

export default component.exports